import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import {CarouselPlugin} from 'bootstrap-vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
// import { VBScrollspy } from 'bootstrap-vue'
import {ModalPlugin} from 'bootstrap-vue';
import {VBTogglePlugin} from 'bootstrap-vue';
import {VBToggle} from 'bootstrap-vue'
// Note: Vue automatically prefixes the directive name with 'v-'
Vue.directive('b-toggle', VBToggle);
Vue.config.productionTip = false;

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(CarouselPlugin);
Vue.use(ModalPlugin);
Vue.use(VBTogglePlugin);
Vue.use(VueAxios, axios);
// Vue.directive('b-scrollspy', VBScrollspy);
export class Notice {
    title: string = "";
    subTitle: string = "";
    poster: string = "";
    texts: Array<any> = [];
    readMore: any = {};
    collapsed: boolean = false;


    constructor(title: string = "", subTitle: string = "", poster: string = "", texts: Array<any> = [], readMore: any = {}, collapsed: boolean = false) {
        this.title = title;
        this.subTitle = subTitle;
        this.poster = poster;
        this.texts = texts;
        this.readMore = readMore;
        this.collapsed = collapsed;
    }
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
